import React, { useState } from "react";

import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/style.css";
import "../Supporting.scss";

interface Props {
  title: string;
  value: any;
  attrName: any;
  value_update: Function;
  warn_status: boolean;
  info_status?: boolean;
  info_message?: string;
  class_name: string;
  error_messg?: string;
  password_status?: boolean;
  type?: string;
}

const defaultProps: Props = {
  title: "",
  value: "",
  attrName: "",
  value_update: () => {},
  warn_status: false,
  info_status: false,
  class_name: "inputField",
  error_messg: "Please enter valid value",
  info_message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
  password_status: false,
};

const UGEmailInput: React.FC<Props> = ({
  title,
  value,
  value_update,
  attrName,
  warn_status,
  class_name,
  error_messg,
  info_status,
  info_message,
  type,
  password_status,
}) => {
  const [emails, setEmails] = useState<string[] | []>([]);
  const [checkEmail, setCheckEmail] = useState<string[] | []>([]);

  const [invalidEmails, setInvalidEmails] = useState<string[] | []>([]);

  console.log("rendering...invalidEmails: ", invalidEmails);

  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [isFieldEmpty, setIsFieldEmpty] = useState<boolean>(true);
  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };
  console.log("emails", emails);
  return (
    <div
      className={`inputField react-multiemail-box ${
        isFocused || checkEmail.length > 0 ? "focused" : ""
      }`}
      onFocus={handleFocus}
      onBlur={handleBlur}
    >
      <ReactMultiEmail
        emails={emails}
        // placeholder={title}
        validateEmail={(email) => {
          /*
            This way you can do custom validation, but if you don't use this it does its own validation under the hood.
          */
          // console.log("validate email: ", email);
          // const isValid = emailRegex.test(email);

          // if (!isValid) {
          //   console.log("NOT VALID!: ", email);
          //   setInvalidEmails([...invalidEmails, email]);
          // }
          // return isValid;
          // return isEmail(email); // return boolean
          return true;
        }}
        onChange={(_emails: string[]) => {
          setCheckEmail(_emails);
          setEmails(emails);
          setIsFieldEmpty(emails.length === 0);

          console.log("set input");
        }}
        getLabel={(
          email: string,
          index: number,
          removeEmail: (index: number) => void
        ) => {
          return (
            <div className="ug_email" data-tag key={index}>
              {email}
              <span data-tag-handle onClick={() => removeEmail(index)}>
                ×
              </span>
            </div>
          );
        }}
      />
      <p
        className={`label ${
          isFocused || checkEmail.length > 0 ? "focused" : ""
        }`}
      >
        {title}
      </p>
    </div>
  );
};

export default UGEmailInput;
